import React from "react";

export const ChevronLeftSvg = ({ className = "" }) => (
    <svg
        className={className}
        width="12"
        height="13"
        viewBox="0 0 12 13"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        aria-hidden="true"
    >
        <path
            transform="scale(-1, 1) translate(-12, 0)"
            id="Vector 335"
            d="M4.125 10.25L7.875 6.5L4.125 2.75"
            stroke="black"
            strokeWidth="1.5"
            strokeLinecap="square"
        />
    </svg>
)